import React from "react";
import { Box, Paper, Typography, Button } from "@mui/material";
import VpnKeyIcon from '@mui/icons-material/VpnKey';

export default function PleaseEnterTokenCard({ onGetTokenClick }) {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="60vh"
      sx={{ px: 2 }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 400,
          width: "100%",
          textAlign: "center",
          borderRadius: 2,
          bgcolor: "background.paper",
          // Animation styles
          animation: 'fadeScaleIn 0.6s ease forwards',
          '@keyframes fadeScaleIn': {
            '0%': { opacity: 0, transform: 'scale(0.8)' },
            '100%': { opacity: 1, transform: 'scale(1)' },
          }
        }}
      >
        <VpnKeyIcon color="primary" sx={{ fontSize: 60, mb: 2, animation: 'iconBounce 2s infinite ease-in-out', '@keyframes iconBounce': {
          '0%, 100%': { transform: 'translateY(0)' },
          '50%': { transform: 'translateY(-10px)' },
        }}} />
        <Typography variant="h5" gutterBottom>
          Authentication Required
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Please enter your API token to proceed.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={onGetTokenClick}
          sx={{ px: 4 }}
        >
          Enter Token
        </Button>
      </Paper>
    </Box>
  );
}
